"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadinessChecker = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
var _ReadinessChecker = require("./ReadinessChecker.styled");
var _helpers = require("./helpers");
var ReadinessChecker = exports.ReadinessChecker = function ReadinessChecker(_ref) {
  var isOpen = _ref.isOpen,
    headerText = _ref.headerText,
    handleCreateSandbox = _ref.handleCreateSandbox,
    sandboxMeetingStatus = _ref.sandboxMeetingStatus,
    speaker = _ref.speaker,
    showSpeakerTest = _ref.showSpeakerTest,
    setShowSpeakerTest = _ref.setShowSpeakerTest,
    onSpeakerStatusChanged = _ref.onSpeakerStatusChanged,
    presenterName = _ref.presenterName,
    camera = _ref.camera,
    cameraFailed = _ref.cameraFailed,
    handleRetry = _ref.handleRetry,
    microphone = _ref.microphone,
    microphoneFailed = _ref.microphoneFailed,
    connectivity = _ref.connectivity,
    udp = _ref.udp,
    tcp = _ref.tcp,
    screenShare = _ref.screenShare,
    handleScreenShareConfirm = _ref.handleScreenShareConfirm,
    showWarning = _ref.showWarning,
    allMajorChecksDone = _ref.allMajorChecksDone,
    warningMessage = _ref.warningMessage,
    success = _ref.success,
    checkCompleted = _ref.checkCompleted,
    handleContinueButtonClick = _ref.handleContinueButtonClick,
    device = _ref.device,
    browser = _ref.browser;
  return _react["default"].createElement(_.StyledModal, {
    isOpen: isOpen,
    fade: false,
    "data-testid": "readiness-check-modal"
  }, _react["default"].createElement(_.StyledModalHeader, {
    className: "dd-privacy-mask"
  }, headerText), _react["default"].createElement(_ReadinessChecker.StyledModalBody, null, "We'll check for access to your camera & microphone, network compatibility, and browser support.", _react["default"].createElement(_ReadinessChecker.StyledTitle, null, "All checks must complete to continue..."), sandboxMeetingStatus.error && _react["default"].createElement(_.Notification, {
    type: "warning",
    onClick: handleCreateSandbox,
    message: "Failed to start the meeting.",
    linkMessage: "Try again",
    isDismissible: false
  }), _react["default"].createElement(_ReadinessChecker.StyledChecksWrapper, {
    disabled: sandboxMeetingStatus.error
  }, _react["default"].createElement(_.DeviceReadiness, {
    status: device,
    statusText: null,
    messageBody: null,
    presenterId: presenterName
  }), _react["default"].createElement(_.BrowserReadiness, {
    status: browser,
    statusText: null,
    messageBody: null,
    presenterId: presenterName
  }), _react["default"].createElement(_.SpeakerReadiness, {
    status: speaker,
    showSpeakerTest: showSpeakerTest,
    onSetShowSpeakerTest: setShowSpeakerTest,
    onSpeakerStatusChanged: onSpeakerStatusChanged,
    presenterId: presenterName
  }), _react["default"].createElement(_.CameraReadiness, {
    status: camera === _.NO_DEVICE_FOUND ? _.FAILED : camera,
    statusText: camera === _.NO_DEVICE_FOUND ? 'No camera device detected' : null,
    messageBody: (0, _helpers.getMessageBody)(camera, true),
    onRetry: function onRetry() {
      return handleRetry('camera');
    },
    presenterId: presenterName,
    camera: camera
  }), _react["default"].createElement(_.MicrophoneReadiness, {
    status: microphone === _.NO_DEVICE_FOUND ? _.FAILED : microphone,
    statusText: microphone === _.NO_DEVICE_FOUND ? 'No microphone device detected' : null,
    messageBody: (0, _helpers.getMessageBody)(microphone),
    onRetry: function onRetry() {
      return handleRetry('microphone');
    },
    presenterId: presenterName,
    microphone: microphone
  }), _react["default"].createElement(_.ConnectivityReadiness, {
    status: connectivity,
    onRetry: function onRetry() {
      return handleRetry('connectivity');
    },
    udp: udp,
    tcp: tcp,
    presenterId: presenterName
  }), _react["default"].createElement(_.ScreenShareReadiness, {
    status: screenShare,
    onConfirm: handleScreenShareConfirm,
    onRetry: function onRetry() {
      return handleRetry('screenShare');
    },
    hideBottomBorder: true,
    presenterId: presenterName
  })), _react["default"].createElement(_ReadinessChecker.StyledContainer, null, _react["default"].createElement(_ReadinessChecker.StyledNotificationChild, {
    fullWidth: showWarning
  }, (checkCompleted() || allMajorChecksDone) && showWarning && _react["default"].createElement(_ReadinessChecker.NotificationWrapper, null, _react["default"].createElement(_.Notification, {
    type: "alert",
    message: warningMessage
  })), success && _react["default"].createElement(_ReadinessChecker.NotificationWrapper, null, _react["default"].createElement(_.Notification, {
    type: "success",
    message: "All required checks have passed!"
  }))), _react["default"].createElement(_ReadinessChecker.ButtonsWrapper, null, _react["default"].createElement(_ReadinessChecker.StyledButtonChild, null, _react["default"].createElement(_ReadinessChecker.StyledButton, {
    className: "dd-privacy-mask",
    "data-testid": "continueButton",
    color: "primary",
    disabled: checkCompleted() ? microphoneFailed || cameraFailed || device === _.FAILED || browser === _.FAILED : true,
    onClick: function onClick() {
      return handleContinueButtonClick();
    },
    "data-dd-action-name": "Continue - (".concat(presenterName, ")")
  }, "Continue")), _react["default"].createElement(_ReadinessChecker.StyledButtonChild, null, _react["default"].createElement(_ReadinessChecker.StyledSkipButton, {
    className: "dd-privacy-mask",
    "data-testid": "skipButton",
    color: "secondary",
    onClick: function onClick() {
      return handleContinueButtonClick(true);
    },
    variant: "outlined",
    "data-dd-action-name": "Skip Readiness Check - (".concat(presenterName, ")")
  }, "Skip"))))));
};